
import './DetailModalContainer.scss';
export default function DetailModalContainer(props: any) {
    return (
        <div className="detail-modal-container ">{props.children}</div>
    );
}